// IMPORTANT: This module utils file isn't in the original eb-ui transformation-utils package

export function normalizeModuleDefault<T>(module: T): T {
    if (module && typeof module === 'object' && 'default' in module) {
        return module.default as T;
    }
    return module;
}
